import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentView from "../../myComp/ContentView";

class TaxList extends PlusComponent {
  constructor(props) {
    super(props, "contentTax");         
  }

  render(){     
    return (
        <div>
          <ContentView {...this.props} title="Info fiscali" controller="contentTax"></ContentView>
        </div>
      )
    }
}

export default TaxList;